import { FileRotateLeftIcon } from './FileRotateLeftIcon';

/**
 * author: Michael Irigoyen
 * id 1111BC67-6DD5-4AE2-9541-9D5E890D823A
 * name file-rotate-left
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-rotate-left.svg
 * tags
 * - Files / Folders 
 */
export const FileRotateCcwIcon = FileRotateLeftIcon;
export default FileRotateCcwIcon